import { ONE_SECOND } from 'constants'
import { SPRINT_TYPE } from '../../constants'
export const data = {
    event_config: {
        visible_start_date: Date.now() + (ONE_SECOND * 10),
        visible_end_date: Date.now() + (ONE_SECOND * 300000),
        name: 'Манёвры',
        sprint_config: {
            sprint_start_date: Date.now() + (ONE_SECOND * 10),
            sprint_end_date: Date.now() + (ONE_SECOND * 300000),
            sprint_number: 21,
            sprint_type: SPRINT_TYPE.GM,
        },
    },
}



// WEBPACK FOOTER //
// ./state/__mocks__/stronghold_maneuvers_mock.js